import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PauseIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z'
                fill='currentColor'
            />
            <Rect x='9' y='8' fill='currentColor' />
            <Rect x='13' y='8' fill='currentColor' />
        </>
    ),
})

PauseIcon.displayName = 'PauseIcon'
